import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HlmToaster} from '@spartan-ng/helm/sonner';
import {ThemeService} from './core/theme/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmToaster],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected readonly theme = inject(ThemeService);
}
